import { defineMessages } from 'react-intl';

export default defineMessages({
  buttonCancel: {
    id: 'view.component.confirmModal.cancelButton',
    defaultMessage: 'Cancel',
  },
});
